export default function AboutSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="o-nas" className="relative bg-background-50 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 xl:gap-24 max-w-7xl mx-auto">
          <div className="w-full lg:w-1/2 relative">
            <div className="relative z-10 overflow-hidden rounded-lg aspect-[4/5] lg:aspect-[3/4]">
              <img
                src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/29f8a11afc46af1a93824a77eee0ece3.png"
                alt="Naša jedilnica – Gostilna Marta"
                title="Gostilna Marta – domača kuhinja in tradicija"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 md:w-48 md:h-48 bg-accent-500/10 rounded-lg"></div>
          </div>

          <div className="w-full lg:w-1/2">
            <p className="welcome-animate font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3 md:mb-4">
              NAŠA ZGODBA
            </p>
            <h2 className="welcome-animate font-heading text-2xl sm:text-3xl md:text-4xl font-light text-foreground-950 leading-tight mb-6 md:mb-8">
              Gostilna z dušo in tradicijo.
            </h2>
            <p className="welcome-animate font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-5 md:mb-6">
              Gostilna Marta je več kot le restavracija – je kraj, kjer se prepletata družinska tradicija in ljubezen do pristne slovenske kuhinje. Že vrsto let z odprtimi vrati sprejemamo goste vseh generacij in jim ponujamo toplino domačega ognjišča.
            </p>
            <p className="welcome-animate font-body text-sm md:text-base text-foreground-600 leading-relaxed mb-8 md:mb-10">
              Vsaka jed, ki zapusti našo kuhinjo, je pripravljena iz skrbno izbranih lokalnih sestavin, po receptih, ki so se prenašali iz roda v rod. Verjamemo, da je dobra hrana tista, ki združuje ljudi – zato pri nas vedno diši po domače.
            </p>

            <div className="welcome-animate flex flex-wrap gap-6 mb-8 md:mb-10">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/12">
                  <i className="ri-leaf-line text-accent-600 text-lg"></i>
                </div>
                <span className="font-label text-sm font-medium text-foreground-800">Lokalne sestavine</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/12">
                  <i className="ri-heart-line text-accent-600 text-lg"></i>
                </div>
                <span className="font-label text-sm font-medium text-foreground-800">Domači recepti</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/12">
                  <i className="ri-group-line text-accent-600 text-lg"></i>
                </div>
                <span className="font-label text-sm font-medium text-foreground-800">Družinsko vzdušje</span>
              </div>
            </div>

            <button
              onClick={() => scrollTo('ponudba')}
              className="welcome-animate inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-300 hover:border-accent-500 text-foreground-800 hover:text-accent-700 text-xs font-label font-medium tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm"
            >
              ODKRIJ VEČ
              <i className="ri-arrow-right-line text-sm"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}